import React from 'react'
import {useState, useRef} from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { startWindow, showWindow, hideWindow, focusWindow, fullScreen, closeWindow } from '../slices/mwSelectSlice';
import Draggable from "react-draggable";
import Background from '../img/emocat.jpg';

const TaskButton = ({taskTitle, mwType, taskIconURL, leftMargin}) => {
    const [hoverState, setHover] = useState(false) 
    const [pressedState, setPressState] = useState(false)
    const [inset, setInset] = useState(true)
    const windowCheck = useSelector((state) => state.shower.window);
    const dispatch = useDispatch()
    const font = '"Inconsolata ", monospace'
    //const bgURL = require(taskIconURL)
    const focusTask = () => {
    
    }

    const setHoverTrue = () => {
        setHover(true)
    }
      
    const setHoverFalse = () => {
        setHover(false)
    }

    const bringWindowOut = () =>{
        if(windowCheck.find((w) => w.windowID === mwType).focus){
            dispatch(hideWindow(mwType))
            setPressState(false)
        }else{
            dispatch(showWindow(mwType))
            dispatch(focusWindow(mwType))
            setPressState(true)
        }
        
        //console.log(bgURL)
    }

    return(
        <div className='taskButton' title={taskTitle} style={{
            //display: 'block',
            zIndex: '10000',
            width: window.innerWidth*.0265*2, 
            height: '75%', 
            backgroundImage: `url(${taskIconURL})`, 
            backgroundRepeat: 'no-repeat',
            backgroundSize: '20%',
            backgroundPositionX: '10%',
            backgroundPositionY: '50%',
            position: 'absolute',
            marginLeft: leftMargin,
            outline: windowCheck.find((w) => w.windowID === mwType).focus  ? 'medium inset  rgb(76, 201, 240)' : 'medium outset rgb(76, 201, 240)',
            outlineOffset: '-5px',
            padding: '5px',
            alignSelf: 'center',
            borderRadius: '10px', 
            }}>
                <button onMouseEnter={setHoverTrue} onMouseLeave={setHoverFalse} onClick={bringWindowOut}
                style={{width: '100%',
                height: '94%',
                backgroundColor: windowCheck.find((w) => w.windowID === mwType).focus  ? 'rgba(255, 255, 255, 0.2)' : hoverState ? 'rgba(255, 255, 255, 0.2)':'transparent',
                border: 'none',
                cursor: 'pointer',
                overflow: 'hidden',
                }}>
                   <p style={{
                    fontSmooth: 'never',  
                    fontSize: '1.3vh',
                    paddingLeft: '25%',
                    verticalAlign: 'center',
                    fontFamily: font,
                   }}>
                    {taskTitle}
                    </p>
                </button>
                
        </div>
    )
}

export default TaskButton